import React from 'react';
import { Button } from '@mui/material';
import { useStyles } from './styles';
import { useTrainerToolsContent as useTrainerTools } from '@features/TrainerTools/provider';

const Tag = ({ tag }: { tag: string }) => {
  const classes = useStyles();

  const { activeTags, changeFilterTags } = useTrainerTools();

  const handleChange = () => {
    changeFilterTags(tag);
  };

  return (
    <Button sx={classes.root(activeTags.includes(tag))} onClick={handleChange}>
      {tag}
    </Button>
  );
};

export default Tag;
